import { format, parseISO } from 'date-fns';

export function convertDateFormat(dateString: string, locale: string): string {
	const date = new Date(dateString);
	const formatter = new Intl.DateTimeFormat(locale, {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	});
	return formatter.format(date);
}

const formatDate = (inputDate: string): string => {
	if (!inputDate) return '-';
	const parsedInputDate = parseISO(inputDate);
	return format(parsedInputDate, 'MMM do, yyyy');
};

export { formatDate };
